import React from "react";
import "./style.css";
import { Modal } from "react-bootstrap";

const CropperModal = ({
  showModal,
  handleModalClose,
  imageRef,
  cropper,
  setLogo,
}) => {
  const handleImageUpload = async (image) => {
    const croppedCanvas = cropper.getCroppedCanvas();
    await croppedCanvas.toBlob(async (blob) => {
      const file = new File([blob], "company_logo", { type: blob.type });
      setLogo(file);
      handleModalClose();
    });
  };

  return (
    <Modal show={showModal} onHide={handleModalClose} centered size="md">
      <Modal.Header closeButton>
        <div className="modal-heading-wrap">
          <h3>
            {" "}
            {/* <span>Choose</span> Your Plan{" "} */}
            <span>Crop</span> Image{" "}
          </h3>
        </div>
      </Modal.Header>
      <Modal.Body style={{ height: "400px", width: "100%" }}>
        <div className="w-100 h-100">
          <img ref={imageRef} alt="crop-item" />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="submit-btn" onClick={handleImageUpload}>
          Crop logo
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CropperModal;
